<script>
import lazyLoadComponent from '@router/lazyload-component'
import { orderStatusFilter, orderSourceFilter, orderPaymentMethodFilter } from '@utils/filter-value-to-text'
import formatDate from '@utils/format-date'
import pageMixin from '@src/mixins/pagination'

export default {
  components: {
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    ReservationOrderDetail: () => lazyLoadComponent(import('@components/Orders/ReservationOrderDetail')),
  },

  filters: {
    orderStatusFilter,
    orderSourceFilter,
    orderPaymentMethodFilter,
    formatDate,
  },
  mixins: [pageMixin],
  data() {
    return {
      loadedOrders: [],
      tryingToGetOrder: false,
      drawerVisible: false,
      drawerOrderData: '',
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build',
      currentPage: 1
    }
  },

  watch: {
    $route: {
      handler: 'tryToSearchOrders',
      immediate: true,
    },
    currentPage: {
      handler: 'tryToSearchOrders',
    },
  },
  methods: {
    calcRowClassName({ row }) {
      const orderStatus = row.status
      const orderUsedStatus = row.groupSize / row.usedSize

      if (orderStatus === 0) return 'order--canceled'
      if (orderUsedStatus === 1) return 'order--used'
    },
    async tryToGetOrder(row) {
      this.tryingToGetOrder = true
      this.drawerOrderData = await this.$store.dispatch('order/fetchSingle', row.id)
      this.tryingToGetOrder = false
      this.drawerVisible = true
    },
    /**
     * @description 一進畫面打API
     */
    async tryToSearchOrders() {
      try {
        const { items, pagination } = await this.$store.dispatch('coupon/getOrders', {
          couponId: this.$route.params.couponId,
          currentPage: this.currentPage,
          paginate: 1
        })
        this.loadedOrders = items
        this.isPaginationShow(pagination)

      } catch (error) {
        console.error(error.message)
      }
    },
    isPaginationShow({ per_page, total }) {
      try {
        if (total > per_page) {
          this.$nextTick(() => {
            this.$refs.pagination && this.$refs.pagination.updateTotal(total)
          })
        }
      } catch (error) {
        console.error(error.message)
      }
    },
  },
}
</script>

<template>
  <div :class="$style.pageContent">
    <BasePageHeader title="使用此優惠券之所有訂單" />
    <el-table v-loading.fullscreen.lock="tryingToGetOrder" element-loading-text="取得訂單資訊中" :data="loadedOrders"
      :default-sort="{ prop: 'date', order: 'descending' }" :row-class-name="calcRowClassName" class="isBgDark"
      @row-click="tryToGetOrder">
      <el-table-column v-slot="{ row }" min-width="160" prop="id" label="訂單編號" sortable>
        <span>#{{ row.id }}</span>
        <br>
        <span class="fs-sm text-secondary-light">
          {{ row.created | formatDate('dateTime') }}
        </span>
      </el-table-column>
      <el-table-column v-slot="{ row }" min-width="100" prop="status" label="訂單狀態" sortable>
        <BaseStateLabel :state="row.status | orderStatusFilter('color')" text>{{ row.status | orderStatusFilter('text') }}
        </BaseStateLabel>
        <br />
        <BaseStateLabel state="secondary-light" text>{{ row.source | orderSourceFilter }}</BaseStateLabel>
        <br />
        <BaseStateLabel class="fs-2sm" state="secondary-light" text>{{ row.paymentMethod | orderPaymentMethodFilter }}
        </BaseStateLabel>
        <br />
        <span class="Jost">${{ row.allActualPayTotal }}</span>
      </el-table-column>
      <el-table-column v-slot="{ row }" prop="productName" min-width="180" label="訂購項目">
        <div>
          <b>{{ row.params[0].title }}</b>
        </div>
        <div class="fs-2sm text-secondary-light">{{ row.date | formatDate }} {{ row.time }}</div>
        <div class="fs-2sm text-secondary-light">{{ row.productName }} </div>
      </el-table-column>
      <el-table-column v-slot="{ row }" prop="date" min-width="130" label="憑證使用日期" sortable>
        <div>{{ row.date | formatDate }}</div>
        <div>{{ row.time }}</div>
      </el-table-column>
      <el-table-column min-width="40">
        <el-tooltip content="查看訂單詳情" placement="top">
          <el-button type="text">
            <BaseIcon name="ellipsis-v" />
          </el-button>
        </el-tooltip>
      </el-table-column>
    </el-table>
    <BasePagination ref="pagination" :current-page.sync="currentPage" />
    <el-drawer ref="orderFormEdit" class="only-close" :class="{ 'appStyle': appStyle }" :visible.sync="drawerVisible"
      append-to-body :size="$root.isSmallDevice ? '100%' : '90%'" destroy-on-close :wrapper-closable="false"
      custom-class="order-drawer">
      <ReservationOrderDetail ref="orderDetail" order-type="reservation" :default-value.sync="drawerOrderData"
        @update="tryToSearchOrders" />
    </el-drawer>
  </div>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

.order-expanded {
  :global {
    .item {
      display: flex;
      align-items: center;
      padding: 20px;
      position: relative;
      align-items: flex-start;

      &.header {
        // background-color: #e2e2df;
        padding: 15px 20px;
      }

      &.header,
      &.no-divider {
        &:after {
          display: none;
        }
      }

      >div {
        flex: 1 1 auto;
        padding: 0 10px;

        &.vs-hide {
          visibility: hidden;
        }

        &.cancel {
          text-decoration: line-through;
          color: #919191;
        }

        &:first-child {
          padding-left: 0;
        }

        &:last-child {
          text-align: right;
          padding-right: 0;
        }

        &:nth-child(1) {
          width: 25%;
        }

        &:nth-child(2) {
          width: 20%;
        }

        &:nth-child(3) {
          width: 10%;
        }

        &:nth-child(4) {
          width: 10%;
        }

        &:nth-child(5) {
          width: 10%;
        }
      }

      &:after {
        content: '';
        position: absolute;
        border-bottom: 1px solid $color-border-base;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 20px;
      }
    }

    .footer {
      text-align: right;
      padding: 20px;

      >div {
        line-height: 20px;
      }

      .total {
        color: $color-text-light;
        margin-bottom: 10px;
      }

      .unpaid {
        color: #e35d5d;
      }
    }
  }
}
</style>
